module.exports = "<app-menu></app-menu>\n<app-report-offer [offer_id]=\"jobId\"></app-report-offer>"


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/reports/reports.component.html
// module id = ../../../../../src/app/pages/reports/reports.component.html
// module chunks = main